import { Button, Row } from 'reactstrap';
import React, { useMemo } from 'react';
import DataTable, { createTheme } from 'react-data-table-component';
import { Col, Card, CardBody } from 'reactstrap';

import "../styles.css";
import FilterListIcon from '@mui/icons-material/FilterList';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import LaunchIcon from '@mui/icons-material/Launch';

function PublicUrls() {
  const REACT_APP_FRONT_URL = process.env.REACT_APP_FRONT_URL;

  const getResultUrl = (eventCategory) => {
    return `${REACT_APP_FRONT_URL}results?event_category=${eventCategory}&start_year=${new Date().getFullYear()}`;
  };


  const publicUrlList = [
    {
      "type": "Overall Ranking",
      "url": REACT_APP_FRONT_URL + "overall_ranking"
    },
    {
      "type": "Agility",
      "url": REACT_APP_FRONT_URL + "ranking?type=Agility"
    },
    {
      "type": "Beagle",
      "url": REACT_APP_FRONT_URL + "ranking?type=Beagle"
    }, {
      "type": "Lure Coursing",
      "url": REACT_APP_FRONT_URL + "ranking?type=Lure Coursing"
    }, {
      "type": "Herding",
      "url": REACT_APP_FRONT_URL + "ranking?type=Herding"
    }, {
      "type": "Pointing Field Trial",
      "url": REACT_APP_FRONT_URL + "ranking?type=Pointing - Field Trial"
    }, {
      "type": "Retriever Field Trial",
      "url": REACT_APP_FRONT_URL + "ranking?type=Retriever Field Trial"
    }, {
      "type": "Spaniel Field Trial",
      "url": REACT_APP_FRONT_URL + "ranking?type=Spaniel Field Trial"
    },
    {
      "type": "Event Result Dispay",
      "url": REACT_APP_FRONT_URL + "results"
    },
    {
      "type": "Junior Handling Result",
      "url": REACT_APP_FRONT_URL + "junior-handling-results"
    },
    {
      "type": "Agility Trials Results",
      "url": getResultUrl("Agility Trials")
    },
    {
      "type": "Beagle Field Trials Results",
      "url": getResultUrl("Beagle Field Trials")
    },
    {
      "type": "Canine Good Neighbour Results",
      "url": getResultUrl("Canine Good Neighbour")
    },
    {
      "type": "Chase Ability Tests Results",
      "url": getResultUrl("Chase Ability Tests")
    },
    {
      "type": "Draft Dog Tests Results",
      "url": getResultUrl("Draft Dog Tests")
    },
    {
      "type": "Earthdog Tests Results",
      "url": getResultUrl("Earthdog Tests")
    },
    {
      "type": "Herding Trials Results",
      "url": getResultUrl("Herding Trials")
    },
    {
      "type": "Lure Coursing Field Trials Results",
      "url": getResultUrl("Lure Coursing Field Trials")
    },
    {
      "type": "Pointing Field Dog Tests Results",
      "url": getResultUrl("Pointing Field Dog Tests")
    },
    {
      "type": "Pointing Field Trials Results",
      "url": getResultUrl("Pointing Field Trials")
    },
    {
      "type": "Pointing Water Tests Results",
      "url": getResultUrl("Pointing Water Tests")
    },
    {
      "type": "Retriever Field Trials Results",
      "url": getResultUrl("Retriever Field Trials")
    },
    {
      "type": "Retriever Hunt Test Results",
      "url": getResultUrl("Retriever Hunt Test")
    },
    {
      "type": "Scent Detection Results",
      "url": getResultUrl("Scent Detection")
    },
    {
      "type": "Spaniel Field Trials Results",
      "url": getResultUrl("Spaniel Field Trials")
    },
    {
      "type": "Spaniel Hunt Test Results",
      "url": getResultUrl("Spaniel Hunt Test")
    },
    {
      "type": "Sprinter Results",
      "url": getResultUrl("Sprinter")
    },
    {
      "type": "Tracking Tests Results",
      "url": getResultUrl("Tracking Tests")
    },
    {
      "type": "Working Certificate Tests Results",
      "url": getResultUrl("Working Certificate Tests")
    },

    {
      "type": "Junior Handling (Conformation)",
      "url": REACT_APP_FRONT_URL + `junior-handling-results?event_category=Junior Handling (Conformation)&start_year=${new Date().getFullYear()}`
    },
    {
      "type": "Junior Handling (Obedience)",
      "url": REACT_APP_FRONT_URL + `junior-handling-results?event_category=Junior Handling (Obedience)&start_year=${new Date().getFullYear()}`
    }

  ];

  const columns = useMemo(() => [
    {
      name: 'Type',
      selector: row => row.type,
      wrap: true,
    },
    {
      name: 'Public URL',
      selector: row => row.url,
      grow: 4,
      center: true,

    },
    {
      name: 'Visit',
      wrap: true,
      cell: row => (<Row>
        <Button color='primary' outline target="_blank" size='sm' href={row.url}><LaunchIcon /></Button>

      </Row>

      ),
    }

  ], []);

  return (
    <div style={{ backgroundColor: '#F1F2F4' }}>

      <div className='page-heading'>

        <Row>
          <Col sm="3">
            Public Standing URL's
          </Col>
          <Col sm="2"></Col>

        </Row>
      </div>


      <ToastContainer />

      <div className='page-body'>
        <Card className="my-2" style={{ padding: 0 }}>
          <CardBody className='event-card-body'>
            <DataTable
              columns={columns}
              data={publicUrlList}
              theme=""
              fixedHeader
              sortIcon={<FilterListIcon />}
            />
          </CardBody>
        </Card>
      </div>


    </div>
  );
}

export default PublicUrls;
